import React, { FC, ReactNode } from 'react'
import { Modal } from 'react-bootstrap'

import './ModalDialog.scss'

interface Props {
  show?: boolean
  autoFocus?: boolean
  onHide?: () => void
  children?: ReactNode
}

export const ModalDialog: FC<Props> = ({ autoFocus = false, ...rest }) => (
  <Modal dialogClassName="modal-dialog-wrapper" {...rest} />
)
